import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

// Compact, reusable "Refer & win" promo. Pulls the current prize and links to /refer.
export function ReferralBanner({ headline, style, compact = false }) {
  const navigate = useNavigate();
  const [prize, setPrize] = useState(null);

  useEffect(() => {
    api.get("/referrals/leaderboard").then((d) => setPrize(d.prize)).catch(() => {});
  }, []);

  const label = prize && ((prize.type === "cash" && prize.value)
    ? `$${Number(prize.value).toFixed(0)} cash`
    : (prize.type === "product" && prize.label) ? prize.label : null);

  return (
    <div
      onClick={() => navigate("/refer")}
      data-testid="referral-banner"
      style={{
        display: "flex", alignItems: "center", gap: 14, cursor: "pointer",
        background: "var(--grad-hero)", color: "#fff", border: "none", borderRadius: 16,
        padding: compact ? "12px 16px" : "16px 20px", ...style,
      }}
    >
      <div style={{ width: compact ? 38 : 46, height: compact ? 38 : 46, borderRadius: 12, background: "rgba(255,255,255,.16)", display: "grid", placeItems: "center", flexShrink: 0 }}>
        <Gift size={compact ? 20 : 24} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 800, fontSize: compact ? 15 : 18 }}>
          {headline || <>Refer &amp; win {label || "monthly prizes"}</>}
        </div>
        {!compact && (
          <div style={{ fontSize: 14, color: "rgba(255,255,255,.85)", marginTop: 2 }}>
            Invite friends who join &amp; shop — the top 5 referrers win every month.
          </div>
        )}
      </div>
      <span className="ss-btn ss-btn-gold ss-btn-sm" style={{ flexShrink: 0 }} data-testid="referral-banner-cta">
        Refer now <ArrowRight size={15} />
      </span>
    </div>
  );
}
